<template>
  <div id="wrapper" :class="{ isPointer }" @click="handleClick($event)">
    <div class="albumContent">
      <img src="~@/assets/contentManagement/album.gif" />
      <span class="albumTitle">{{ albumTitle }}</span>
    </div>
  </div>
</template>

<script>
/**
 * 专辑名称显示
 * @ 使用场景 1 内容管理页面显示专辑名称 2 内容详情页面显示专辑名称
 * @ 参数说明
 *
 * albumTitle: 专辑名称内容
 *
 * isPointer: 游标是否为小手
 *
 *  */
export default {
  props: {
    albumTitle: {
      type: String,
      default: '',
    },
    isPointer: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 点击事件
    handleClick(env) {
      this.$emit('click', env)
    },
  },
}
</script>

<style scoped>
#wrapper {
  box-sizing: border-box;
  position: relative;
  display: inline-block;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 5px 10px;
  height: 28px;
}
.albumContent img {
  margin-top: -1px;
}

.albumTitle {
  position: relative;
  font-family: 'Microsoft YaHei';
  font-size: 13px;
  line-height: 18px;
  color: #666666;
  margin-left: 6px;
  bottom: 5px;
}
.isPointer {
  cursor: pointer;
}
</style>
